import { useState, useEffect } from "react";
import { Col, Row, Alert } from "react-bootstrap";

export const Newsletter = () => {
  // Zustände für das Ausklappen von "passiv" und "aktiv"
  const [isPassiveExpanded, setIsPassiveExpanded] = useState(false);
  const [isActiveExpanded, setIsActiveExpanded] = useState(false);

  // Funktionen zum Umschalten des jeweiligen Textes
  const togglePassiveText = () => setIsPassiveExpanded(!isPassiveExpanded);
  const toggleActiveText = () => setIsActiveExpanded(!isActiveExpanded);

  return (
    <section className="Kontaktformular" id="Formular">
    <div className="newsletter-bx wow slideInUp">
      <h3>
        Du hast Lust bekommen, bei uns Mitglied zu werden?<br/> Dann werde jetzt Mitglied - 
        <span
          onClick={togglePassiveText}
          style={{ color: 'red', cursor: 'pointer', marginLeft: '5px', marginRight: '5px' }}
          className="hover-link"
        >
          <em>passiv</em>
        </span>
        oder
        <span
          onClick={toggleActiveText}
          style={{ color: 'red', cursor: 'pointer', marginLeft: '5px', marginRight: '5px' }}
          className="hover-link"
        >
          <em>aktiv</em>
        </span>
        - sei dabei!
      </h3>

      {/* Ausklappbarer Text für "passiv" */}
      {isPassiveExpanded && (
        <div style={{ marginTop: '5px', color: 'black', fontWeight: 'normal' }}>
          <p>
            <h5 style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>Passive Mitgliedschaft:</h5>
            <p style={{fontSize: '20px', color: 'black', fontWeight: 'normal' }}>
            Passive Mitglieder unterstützen den Verein mit einem Beitrag von derzeit 9,99€/ Jahr. Hierfür musst du ebenfalls den Mitgliedsantrag ausdrucken, ausfüllen und abschicken.
            </p>
            <a href="/assets/AufnahmePassiv.pdf" target="_blank" rel="noopener noreferrer" className="hover-link" style={{ color: 'red', cursor: 'pointer', display: 'inline-block', marginLeft: '5px', marginRight: '5px' }}>
            <h5><em>Passives Mitgliedschaftsformular</em></h5>
            </a>
          </p>
        </div>
      )}

      {/* Ausklappbarer Text für "aktiv" */}
      {isActiveExpanded && (
        <div style={{ marginTop: '5px', color: 'black', fontWeight: 'normal' }}>
          <p>
            <h5 style={{ color: 'black', fontWeight: 'bold', textDecoration: 'underline' }}>Aktive Mitgliedschaft:</h5>
            <p style={{fontSize: '20px', color: 'black', fontWeight: 'normal' }}>
            Frei nach dem Motto: Mitglied werden ist nicht schwer - Mitglied sein dagegen sehr. Lade Dir hier den Antrag herunter, drucke ihn aus, ausfüllen und abschicken!
            <br/> Die Bearbeitung der aktiven Anträge die das Jahr über bei uns eingehen erfolgt im Mai und Juni eines Jahres. In dieser Zeit erhältst Du von uns Post mit der Einladung zu einem Vorstellungs- und Informationsabend, dort erfährst du alles was für dich wichtig ist.
            </p>
            <a href="/assets/AufnahmeAktiv.pdf" target="_blank" rel="noopener noreferrer" className="hover-link" style={{ color: 'red', cursor: 'pointer', display: 'inline-block', marginLeft: '5px', marginRight: '5px' }}>
            <h5><em>Aktives Mitgliedschaftsformular</em></h5>
            </a>
          </p>
        </div>
      )}
    </div>
    </section>
  );
};
    